export default {
    H1: 'header-one',
    H2: 'header-two',
    H3: 'header-three',
    H4: 'header-four',
    H5: 'header-five',
    H6: 'header-six',
    UL: 'unordered-list-item',
    OL: 'ordered-list-item',
    BLOCKQUOTE: 'blockquote',
    CODE_BLOCK: 'code-block',
    UNSTYLED: 'unstyled',
    ATOMIC: 'atomic',
};
